/* Grayscale css filter workaround with canvas. */
var GrayscaleCanvas = function(gal) {
    var _this = this;

    function _initCanvasForProduct(inx, prod) {
        var $prod = $(prod),
            pImgSrc = $prod.find('.p-img-wrap').css('background-image');

        $prod.find('.p-img-wrap').remove();
        $prod.prepend('<canvas class="p-img-wrap" />');

        var canvas = $prod.find('canvas.p-img-wrap')[0],
        	ctx = canvas.getContext('2d');

        var image = new Image(),
            originalPixelsData,
            imageSrc = pImgSrc.slice(4, -1).replace(/["|']/g, "");

        image.onload = function() {
            canvas.width = canvas.clientWidth;
            canvas.height = canvas.clientHeight;

            var imgToCanvasW = (canvas.height / this.height) * this.width;
            var canvasXCenter = (canvas.width - imgToCanvasW) / 2;

            ctx.drawImage(this, 0, 0, this.width, this.height, canvasXCenter, 0, imgToCanvasW, canvas.height);
            originalPixelsData = ctx.getImageData(0, 0, this.width, this.height);
            _grayScale(canvas, ctx);
        };

        image.crossOrigin = "Anonymous";
        image.src = imageSrc;
    }

    function _grayScale(canvas, ctx) {

        var pixelsData = ctx.getImageData(0, 0, canvas.width, canvas.height),
            data = pixelsData.data;

        for (var i = 0, len = data.length; i < len; i += 4) {
            var avgP = (data[i] + data[i + 1] + data[i + 2]) / 3;
            data[i] = avgP;
            data[i + 1] = avgP;
            data[i + 2] = avgP;
        }

        ctx.putImageData(pixelsData, 0, 0);
    }

    function _init() {
        var $inactiveProducts = $(gal.gallery.currItem.container).find('.product-wrap.inactive .p-inner-wrap');

        $inactiveProducts.each(function(inx, $prod) {
            _initCanvasForProduct(inx, $prod);
        });
    }

    _this.init = _init;
};